import lodash from 'lodash';
import React from 'react';

import type { RicosTheme } from './../ricos-types';

import { THEME_DEFAULTS } from './theme-defaults';

const ThemeContext = React.createContext<RicosTheme>({});

export const ThemeProvider: React.FC<{
  isMobile?: boolean;
  theme?: RicosTheme;
  children: React.ReactNode;
}> = ({ isMobile = false, theme = {}, children }) => {
  const value = React.useMemo(() => {
    const defaultTheme = isMobile ? THEME_DEFAULTS.mobile : THEME_DEFAULTS.desktop;
    return lodash.merge({}, defaultTheme, theme);
  }, [theme, isMobile]);

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
};

export const useTheme = () => React.useContext(ThemeContext);
